import React from "react";
import { Link } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import "../BtnBlanc/btn-blanc.scss";
import BtnBlanc from "../BtnBlanc/btn-blanc";

/**
 * Permet d'afficher les boutons blancs
 */
const BtnRetour = () => {
  return (
    <Link to={{ pathname: `/profil` }}>
      <BtnBlanc btnIcone={<FaChevronLeft />} btnTexte={"Mon profil"} />
    </Link>
  );
};

export default BtnRetour;
